import React, { useEffect, useState } from "react";
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BottomMenu from "../../../../components/common/Authenticated/Menu/Menu";
import config from "../../../../consts.js";

function MeuPerfil() {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const usuarioStorage = JSON.parse(localStorage.getItem("usuario")) || {};
  const [loading, setLoading] = useState(false);

  const [usuario, setUsuario] = useState({
    nome: "",
    telefone: "",
    email: "",
    dataNascimento: "",
    sexo: "Feminino",
    documento: { tipo: "CPF", numero: "" },
    endereco: {
      cidade: "",
      uf: "",
      cep: "",
      numero: "",
      logradouro: "",
      pais: "Brasil",
    },
  });

  const paisMap = {
    br: "Brasil",
    us: "Estados Unidos",
    pt: "Portugal"
  };

  const paisExibicao = paisMap[usuario.endereco.pais] || usuario.endereco.pais;

  // 👉 Carrega os dados do storage ao montar o componente
  useEffect(() => {
    if (usuarioStorage) {
      setUsuario(usuarioStorage);
    }
  }, []);

  const Voltar = () => navigate("/area-restrita/minha-conta");

  const handleCampoChange = (nomeCampo, valor) => {
  const [campo, subcampo] = nomeCampo.split(".");

  if (campo === "documento" && subcampo === "tipo") {
    setUsuario((prev) => ({
      ...prev,
      documento: { ...prev.documento, tipo: valor, numero: "" },
    }));
    return;
  }

  if (subcampo) {
    setUsuario((prev) => ({
      ...prev,
      [campo]: {
        ...prev[campo],
        [subcampo]:
          subcampo === "numero" && campo === "documento"
            ? valor.replace(/\D/g, "") // só remove não-dígitos para documento
            : valor, // para cidade, uf, etc, mantém tudo
      },
    }));
  } else {
    setUsuario((prev) => ({
      ...prev,
      [campo]:
        campo === "telefone"
          ? valor.replace(/\D/g, "") // só remove não-dígitos para telefone
          : valor,
    }));
  }
};


  const formatarDocumento = (tipo, numero) => {
    if (!numero) return "";
    if (tipo === "CPF" && numero.length === 11) {
      return numero.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    }
    if (tipo === "CNPJ" && numero.length === 14) {
      return numero.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        "$1.$2.$3/$4-$5"
      );
    }
    return numero;
  };

  const enviarAtualizacao = async () => {
    try {
      setLoading(true);
      const clienteId = usuarioStorage._id; // ID do cliente no storage
      if (!clienteId) return alert("Cliente não encontrado");

      // Clona objeto para enviar
      const payload = { ...usuario };

      // Mapeia sexo
      payload.sexo = payload.sexo === "Masculino" ? "M" : "F";

      // Mapeia documento
      payload.documento.tipo = payload.documento.tipo === "CPF" ? "cpf" : "cnpj";

      const response = await axios.put(
        `${config.baseURL}/cliente/${clienteId}`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (!response.data.error) {
        alert("Perfil atualizado com sucesso!");
        localStorage.setItem("usuario", JSON.stringify(response.data.cliente));
        setUsuario(response.data.cliente);
        navigate("/area-restrita/minha-conta");
      } else {
        alert("Erro: " + response.data.message);
      }
    } catch (err) {
      console.error(err);
      alert("Erro ao atualizar perfil.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="relative bg-white min-h-screen p-5 pb-8 mb-12 sm:pb-24">
        <button
          onClick={Voltar}
          className="absolute top-3 left-2 bg-[#003D42] p-2 rounded-full z-10 flex items-center justify-center shadow-md w-9"
        >
          <ChevronLeft size={20} color="#fff" />
        </button>

        <h1 className="text-2xl font-semibold text-center mt-10">
          Edite as suas informações cadastrais
        </h1>

        <div className="mt-6 space-y-6 max-w-2xl mx-auto">
          <h2 className="text-lg font-semibold">Informações pessoais</h2>

          <input
            type="text"
            className="w-full border rounded-md p-2"
            placeholder="Nome"
            value={usuario.nome}
            onChange={(e) => handleCampoChange("nome", e.target.value)}
          />

          <input
            type="tel"
            className="w-full border rounded-md p-2"
            placeholder="Telefone"
            value={usuario.telefone}
            onChange={(e) => handleCampoChange("telefone", e.target.value)}
          />

          <input
            type="email"
            className="w-full border rounded-md p-2"
            placeholder="E-mail"
            value={usuario.email}
            onChange={(e) => handleCampoChange("email", e.target.value)}
          />

          <div className="flex gap-4">
            <div className="flex flex-col w-1/2">
              <label className="text-sm">Data de Nascimento</label>
              <input
                type="date"
                className="border border-[0.1px] border-black rounded-md p-2 h-6 md:h-auto bg-white text-black"
                value={usuario.dataNascimento}
                onChange={(e) =>
                  handleCampoChange("dataNascimento", e.target.value)
                }
              />
            </div>

            <div className="flex flex-col w-1/2">
              <label className="text-sm">Gênero</label>
              <select
                className="border border-[0.1px] border-black rounded-md p-2 h-6 md:h-auto bg-white text-black" 
                value={usuario.sexo}
                onChange={(e) => handleCampoChange("sexo", e.target.value)}
              >
                <option value="Masculino">Masculino</option>
                <option value="Feminino">Feminino</option>
              </select>
            </div>
          </div>

          <h2 className="text-lg font-semibold">Documento</h2>
          <div className="flex gap-4">
            <select
              className="border rounded-md p-2 w-1/2"
              disabled={true}
              value={usuario.documento.tipo}
              onChange={(e) =>
                handleCampoChange("documento.tipo", e.target.value)
              }
            >
              <option value="CPF">CPF</option>
              <option value="CNPJ">CNPJ</option>
            </select>

            <input
              type="text"
              className="border rounded-md p-2 w-1/2"
              placeholder="Número do documento"
              value={formatarDocumento(
                usuario.documento.tipo,
                usuario.documento.numero
              )}
              onChange={(e) =>
                handleCampoChange("documento.numero", e.target.value)
              }
            />
          </div>

          <h2 className="text-lg font-semibold">Endereço</h2>

          <div className="flex gap-4">
            <input
              type="text"
              className="border rounded-md p-2 w-1/2"
              placeholder="Cidade"
              value={usuario.endereco.cidade}
              onChange={(e) =>
                handleCampoChange("endereco.cidade", e.target.value)
              }
            />
            <input
              type="text"
              className="border rounded-md p-2 w-1/2"
              placeholder="UF"
              value={usuario.endereco.uf}
              onChange={(e) => handleCampoChange("endereco.uf", e.target.value)}
            />
          </div>

          <div className="flex gap-4">
            <input
              type="text"
              className="border rounded-md p-2 w-1/2"
              placeholder="CEP"
              value={usuario.endereco.cep}
              onChange={(e) =>
                handleCampoChange("endereco.cep", e.target.value)
              }
            />
            <input
              type="text"
              className="border rounded-md p-2 w-1/2"
              placeholder="Número"
              value={usuario.endereco.numero}
              onChange={(e) =>
                handleCampoChange("endereco.numero", e.target.value)
              }
            />
          </div>

          <div className="flex gap-4">
            <input
              type="text"
              className="border rounded-md p-2 w-1/2"
              placeholder="Logradouro"
              value={usuario.endereco.logradouro}
              onChange={(e) =>
                handleCampoChange("endereco.logradouro", e.target.value)
              }
            />
            <input
              type="text"
              className="border rounded-md p-2 w-1/2 bg-gray-100"
              placeholder="País"
              value={paisMap[usuario.endereco.pais] || usuario.endereco.pais}
              disabled
            />
          </div>

          <button
            onClick={enviarAtualizacao}
            disabled={loading}
            className={`mt-6 w-full bg-[#003D42] text-white font-semibold py-3 rounded-md shadow-md hover:bg-[#002d30] transition ${
              loading ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            {loading ? "Atualizando..." : "Atualizar informações"}
          </button>
        </div>
      </div>
      <BottomMenu />
    </>
  );
}

export default MeuPerfil;
